import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/shared/components/ui/Button';

interface SignalErrorStateProps {
  error: Error | unknown;
  onRetry: () => void;
}

export const SignalErrorState = ({ error, onRetry }: SignalErrorStateProps) => {
  const { t } = useTranslation('knowledge');

  return (
    <div className="text-center py-16">
      <div className="mx-auto w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-4">
        <AlertCircle className="h-12 w-12 text-red-600" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {t('errorLoadingSignals')}
      </h3>
      <p className="text-gray-600 mb-6">
        {error instanceof Error ? error.message : t('unexpectedError')}
      </p>
      <Button onClick={onRetry}>{t('retry')}</Button>
    </div>
  );
};
